<template>
    <div class="mycontent-board-write">
        <button-header leftTitle="취소" title="글쓰기" rightTitle="등록" v-on:leftClickEvent="leftClickEvent" v-on:rightClickEvent="rightClickEvent" />

        <div class="board-input">
            <div>제목</div>
            <div>
                <input type="text" placeholder="제목을 입력해주세요." v-model="board.title" />
            </div>
        </div>
        <div class="board-textarea">
            <textarea placeholder="내용을 입력해 주세요." maxlength="1000" v-model="board.contents"></textarea>
        </div>
        <!--<div class="board-files">
            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/mypage/qna-picture.png" width="26" height="24" />
            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/mypage/qna-files.png" width="26" height="25" />
        </div>-->
    </div>
</template>

<script>
    import * as biz from '../../utils/biz'
    import * as ajax from '../../utils/ajax'
    import * as alert from '../../utils/alert'
    import ButtonHeader from "../../components/header/ButtonHeader";

    export default {
        name: 'WriteBoard',
        components: {ButtonHeader},
        data() {
            return {
                board: {
                    title: "",
                    contents: "",
                    board_div: "30",
                    regist_user: 1
                }
            }
        },
        created() {
            this.$store.state.toolbarActivePosition = "join";
            this.$store.state.basicPlayerVisiblity = false;
        },
        methods: {
            leftClickEvent() {
                this.$router.go(-1)
            },
            rightClickEvent() {
                const params = this.board;
                ajax.Post(this, "/api/board/communication/", params, function(ref, data) {
                    alert.alert("게시글이 등록 되었습니다.", "확인");
                    ref.$router.go(-1);
                });
            }
        },
        computed: {
        }
    }
</script>

<style scoped lang="scss">
    div.mycontent-board-write {
        overflow-y: auto;
        min-height: 100vh;
        background-color: $seventh-color;

        div.board-input {
            padding: 12px 24px;
            background-color: $seventh-color;

            input {
                width: 100%;
                padding: 6px 6px 6px 0;
                border: 0;
                border-bottom: 1px solid $line-secondary-color;
                background-color: $seventh-color;
            }
        }

        div.board-textarea {
            padding: 12px 24px;
            background-color: $seventh-color;

            textarea {
                width: 100%;
                height: 340px;
                border: 0;
                border-bottom: 1px solid $line-secondary-color;
                background-color: $seventh-color;
            }
            div.textarea_count {
                text-align: right;

                span {
                    color: $primary-color;
                }
            }
        }
        div.board-files {
            padding: 12px 24px;
            background-color: $seventh-color;
            min-height: calc(100vh - 503px);

            img:first-child {
                margin-right: 30px;
            }
        }
    }
</style>
